import { RootState } from '..';

export const selectDictionaries = (state: RootState) => state.site.dictionaries;
